// extracted by mini-css-extract-plugin
export default {"newUser":"UserManagement_newUser__4Pibz","buttons":"UserManagement_buttons__xBeNx"};